import React, { useState } from "react";
import {
  Modal,
  Box,
  CardContent,
  Typography,
  IconButton,
  TextField,
  Button,
  styled,
  FormControl,
  InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import axios from "axios";
import { API_BASE_URL } from "../../../apiConfig";
import ArticleEditor from "../manageStores/ArticleEditor";
import LocalGroceryStoreIcon from "@mui/icons-material/LocalGroceryStore";
import LinkIcon from "@mui/icons-material/Link";
import { refreshTokenIfNeeded } from "../refreshTokenIfNeeded";
import { useNavigate } from "react-router-dom";

const StyledCard = styled(Box)(({ theme }) => ({
  backgroundColor: "#fff",
  borderRadius: "10px",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  maxWidth: "1200px",
  width: "77%",
  margin: "auto",
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: 1200,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

function AddCoupon({ storeId, onClose, onSubmit, error }) {
  const [couponData, setCouponData] = useState({
    storeID: storeId || "",
    couponTitle: "",
    couponDescription: "",
    couponCode: "",
    affiliatelink: "",
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    if (typeof e === "string") {
      setCouponData((prevData) => ({
        ...prevData,
        couponDescription: e,
      }));
    } else if (e?.target) {
      const { name, value } = e.target;
      setCouponData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    } else {
      console.alert("Unhandled event structure:", e);
    }
  };

  const handleSubmit = async () => {
    if (
      !couponData.storeID ||
      !couponData.couponTitle ||
      !couponData.couponDescription ||
      !couponData.couponCode ||
      !couponData.affiliatelink
    ) {
      alert("يرجى ملئ الحقول المطلوبة");
      return;
    }

    const token = localStorage.getItem("token");

    const newCoupon = {
      ...couponData,
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}Coupon/AddNew`,
        newCoupon,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      alert("تم اضافة الكوبون بنجاح");
      onSubmit();
      onClose();
    } catch (error) {
      if (error.response?.status === 401) {
        try {
          const newToken = await refreshTokenIfNeeded();

          if (!newToken) {
            return navigate("/", { replace: true });
          }

          // إعادة الطلب بالتوكن الجديد
          const response = await axios.post(
            `${API_BASE_URL}Coupon/AddNew`,
            newCoupon,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${newToken}`,
              },
            },
          );

          alert("تم اضافة الكوبون بنجاح");
          onSubmit();
          onClose();
        } catch (retryError) {
          alert("Retry failed: " + retryError.message);
        }
      } else {
        alert("Error adding user: " + (error.response?.data || error.message));
      }
    }
  };

  return (
    <Modal
      dir="rtl"
      open={true}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <StyledCard>
          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", top: 16, right: 16 }}
          >
            <CloseIcon />
          </IconButton>
          <CardContent sx={{ textAlign: "right", mt: 2 }}>
            {error && <Typography color="error">{error}</Typography>}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "3%",
                fontFamily: "'Changa', sans-serif",
              }}
            >
              <h3>إضافة كوبون جديد</h3>
            </div>

            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
            >
              {/* الصورة على اليسار */}
              <Box
                sx={{
                  width: "40%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FormControl fullWidth sx={{ marginBottom: 2 }}>
                  <TextField
                    placeholder="عنوان الكوبون"
                    value={couponData.couponTitle}
                    name="couponTitle"
                    onChange={handleChange}
                    variant="outlined"
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "4px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#5b5b5c",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#5b5b5c",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#0064b7",
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LocalGroceryStoreIcon sx={{ color: "green" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>

                <FormControl fullWidth sx={{ marginBottom: 2 }}>
                  <TextField
                    placeholder="كود الخصم"
                    value={couponData.couponCode}
                    name="couponCode"
                    onChange={handleChange}
                    variant="outlined"
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "4px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#5b5b5c",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#5b5b5c",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#0064b7",
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <DriveFileRenameOutlineIcon sx={{ color: "blue" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>

                <FormControl fullWidth sx={{ marginBottom: 2 }}>
                  <TextField
                    placeholder="رابط الافلييت"
                    value={couponData.affiliatelink}
                    name="affiliatelink"
                    onChange={handleChange}
                    variant="outlined"
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "4px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#5b5b5c",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#5b5b5c",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#0064b7",
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LinkIcon sx={{ color: "green" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </Box>
              <Box sx={{ width: "55%" }}>
                <FormControl fullWidth sx={{ marginBottom: 1 }}>
                  <ArticleEditor
                    placeholder="الوصف"
                    value={couponData.couponDescription}
                    name="couponDescription"
                    onChange={handleChange}
                    variant="outlined"
                  />
                </FormControl>
              </Box>
            </Box>

            <Box sx={{ textAlign: "center", mt: 4 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
              >
                إضافة الكوبون
              </Button>
            </Box>
          </CardContent>
        </StyledCard>
      </Box>
    </Modal>
  );
}

export default AddCoupon;
